import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'

import { TimezoneSetting } from './TimezoneSetting'

export function Settings() {
    return (
        <Tabs colorScheme="blue">
            <TabList>
                <Tab>App Timezone</Tab>
            </TabList>

            <TabPanels>
                <TabPanel px={0} pt={6}>
                    <TimezoneSetting />
                </TabPanel>
            </TabPanels>
        </Tabs>
    )
}
